import MaterialDialogContentText, {
    DialogContentTextProps,
} from '@mui/material/DialogContentText';

export function DialogContentText(props: DialogContentTextProps) {
    return (
        <MaterialDialogContentText
            data-testid={'DialogContentText-container'}
            {...props}
        />
    );
}

export default DialogContentText;
